import React from "react";

import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

export type LinkItem = {
  label: string;
  href: string;
};

type MenuLinkProps = {
  icon: React.ReactNode;
  label: string;
  links: LinkItem[];
};

const MenuLink: React.FC<MenuLinkProps> = ({ icon, label, links }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (href: string) => {
    handleClose();
    window.open(href, "_blank");
  };

  return (
    <>
      <Button
        onClick={handleClick}
        endIcon={<KeyboardArrowUpIcon />}
        size={"small"}
        startIcon={icon}
        color={"inherit"}
        sx={{ fontSize: "12px" }}
      >
        {label}
      </Button>
      <Menu
        id="customized-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {links.map((link) => (
          <MenuItem key={link.href} onClick={() => handleMenuItemClick(link.href)}>
            {link.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MenuLink;
